<script setup>
import {defineProps, defineEmits} from 'vue';

defineProps({
    pollutant: {
        type: Object,
        required: true
    }
});

const emit = defineEmits(['close']);
const close = () => emit('close');
</script>

<template>
    <div class="PollutantModal">
        <div class="PollutantModal__left">
            <img :src="'molecules/' + pollutant.image_base + '-sel.png'" :alt="pollutant.label" class="Pollutant__image-main" />

            {{pollutant.label}}

            <button @click="close">×</button>
        </div>
        <div class="PollutantModal__right">
            <p v-for="(info, index) in pollutant.info" :key="index">
                {{info}}
            </p>
        </div>
    </div>
</template>


<style lang="scss" scoped>
.PollutantModal {
    position: absolute;
    top: 40px;
    left: 50%;
    transform: translate(-50%);
    display: flex;
    color: #fff;
    font-size: 14px;
    z-index: 10;

    &__left {
        background: #118075;
        width: 170px;
        height: 170px;
        border: 1px solid #fff;
        text-align: center;
        padding: 25px;
        position: relative;

        img {
            width: 100%;
        }

        button {
            background: red;
            position: absolute;
            left: 0;
            bottom: 0;
            transform: translate(-50%, 50%);
            width: 24px;
            height: 24px;
            border: 0;
            border-radius: 50%;
            color: #fff;
            font-size: 20px;
            cursor: pointer;

            &:hover {
                background: darkred;
            }
        }
    }

    &__right {
        background: #118075;
        padding: 20px 12px;
        border: 1px solid #fff;
        width: 240px;
        left: -1px;
        position: relative;
    }
}
</style>
